import {
    Form,
    Input,
    ModalProps,
    FormProps,
    Modal,
    useSelect,
    Select
} from "@pankod/refine-antd";
import { useGetIdentity } from "@pankod/refine-core";
import { useUserContext } from "context/user";
import { createUserHistory } from "gql/mutations";

type EditTeacherLevelProps = {
    modalProps: ModalProps;
    formProps: FormProps;
};

export const EditTeacherLevel: React.FC<EditTeacherLevelProps> = ({
    modalProps,
    formProps,
}) => {
    const { data: user } = useGetIdentity();
    const { userRole } = useUserContext()
    const onFinish = async (values: any) => {
        return (
            formProps.onFinish &&
            formProps.onFinish({
                ...values,
                updated_by: user?.id

            })
        )
    }
    return (
        <Modal {...modalProps} title="Edit Teacher Level">
            <Form {...formProps} layout="vertical" onFinish={async values => {
                let response = await onFinish(values).then((response: any) => {
                    if (response) {
                        createUserHistory('teacher_levels', 'edit', response?.data?.id, user?.id, userRole)
                    }

                })

                return response
            }} >
                <Form.Item
                    label="Teacher Level"
                    name="name"
                    rules={[
                        {
                            required: true,
                        },
                    ]}
                >
                    <Input />
                </Form.Item>
                <Form.Item name="updated_by"
                    initialValue={user?.id}>
                    <Input type="hidden" />
                </Form.Item>
            </Form>
        </Modal>
    );
};
